import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  open: boolean;
  title?: string;
  onClose: () => void;
  children?: ReactNode;
  helperText?: string;
  helperLink?: string;
};

const VNInfoDrawer = ({ open, title = 'Help', onClose, children, helperText, helperLink }: Props) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    className="vn-info-drawer"
    PaperProps={{ className: 'vn-info-drawer__paper' }}
  >
    <Box className="vn-info-drawer__header">
      <Typography variant="h6" component="h2" className="vn-info-drawer__title">
        {title}
      </Typography>
      <IconButton onClick={onClose} aria-label="Close help drawer" size="small">
        <CloseIcon />
      </IconButton>
    </Box>
    <Box className="vn-info-drawer__body">
      {children}
      {helperText && <p className="vn-info-drawer__helper-text">{helperText}</p>}
      {helperLink && (
        <a className="vn-field-help__learn-more vn-info-drawer__link" href={helperLink} target="_blank" rel="noopener noreferrer">
          Learn More
        </a>
      )}
    </Box>
  </Drawer>
);

export default VNInfoDrawer;
